import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import ddo from '../../ddo.js'
import Dt_Cal from "../../lib/ui/dt_cal";
import Tax_Edit from "./tax/tax_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Bo_Tax extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;

    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = ddo.cache.avd;
    this.state.taa = [];
    this.state.aa = [];
    this.state.taxedit = false;
    this.state.wnds = {};
    if(this.pos.deps) this.state.aa = this.pos.deps;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.taxes();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  tax_edit(row) {
    var self = this;
    //alert(JSON.stringify(row.bet00));
    //var bto = JSON.parse(JSON.stringify(row.bet00));
    var wnds = {};
    wnds.taxedit = true;
    wnds.dao = row;
    wnds.backdrop = true;
    self.setState({wnds: wnds });
  }

  taxes() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_tax.taxes";
    prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({taa: ret.raa });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  change_avd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({avd: avd});
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <select className="form-control w250" placeholder="Välj avdelning" onChange={(e) => this.change_avd(e)}>
            { this.props.store.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text}</option>
            )}
        </select>
        <div className="flex"></div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.taxes() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>Kod</th>
                <th>Text</th>
                <th>Moms</th>
                <th>Konto</th>
                <th>Uppdat</th>
                <th>Sign</th>
                <th style={{width:"40px"}} ></th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.taa.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.tax_edit(row) }>
                <td>{ row.mom00.m0kod }</td>
                <td>{ row.mom00.m0txt }</td>
                <td>{ row.mom00.m0moms }</td>
                <td>{ row.mom00.m0konto }</td>
                <td>{ row.mom00.m0upddat }</td>
                <td>{ row.mom00.m0sign }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.tax_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    { this.state.wnds.taxedit ? <Tax_Edit wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
  );
    }
}
export default Bo_Tax;
